import { Link } from "react-router-dom";
import { useContext } from "react";
import { AppContext } from "../../contexts/AppContext";

const ActionVolonter = () => {
  const { language } = useContext(AppContext);

  const title = [
    'Стати волонтером "Stronger Together"',
    "Devenez bénévole chez Stronger Together",
    "Volunteer at Stronger Together",
  ];
  const text = [
    "Ви не маєте фінансових можливостей підтримати Україну, але ви все одно хочете допомогти? У вас є 1, 5 або 20 годин на тиждень, щоб присвятити їх справі? Ставайте волонтерами «Stronger Together»!",
    "Vous n'avez pas les moyens financiers de soutenir l'Ukraine, mais vous voulez quand même aider ? Vous avez 1, 5, 20 heures par semaine à consacrer à la cause ? Portez-vous volontaire pour Stronger Together!",
    "If you have no financial means to support Ukraine, but you still want to help? Do you have 1, 5, 20 hours a week to devote to the cause? Volunteer for Stronger Together!",
  ];
  const link = ["Стати волонтером", "Appliquer", "Join our team"];
  const professions = [
    <svg
      className="fill-lightBlue w-full h-full"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 190"
      enableBackground="new 0 0 256 190"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path d="M48.12,27.903C48.12,13.564,59.592,2,74.023,2c14.339,0,25.903,11.564,25.903,25.903 C99.834,42.335,88.27,53.806,74.023,53.806C59.684,53.806,48.12,42.242,48.12,27.903z M191,139h-47V97c0-20.461-17.881-37-38-37H43 C20.912,60,1.99,79.14,2,98v77c-0.026,8.533,6.001,12.989,12,13c6.014,0.011,12-4.445,12-13v-75h8v88h78v-88h8l0.081,50.37 c-0.053,8.729,5.342,12.446,10.919,12.63h60C207.363,163,207.363,139,191,139z M252.209,94.097h0.292H254 c0,10.163-8.206,18.369-18.369,18.369s-18.369-8.247-18.369-18.369h1.749h0.292l12.662-41.861h-24.033v65.144h23.783v9.33h-3.041 h-23.534h-23.534h-3.041v-9.33h23.783V52.237h-24.033l12.662,41.861h0.292h1.749c0,10.163-8.206,18.369-18.369,18.369 s-18.369-8.247-18.369-18.369h1.499h0.292l13.412-44.61h30.614v-5.581c0-1.541,1.541-3.041,3.041-3.041 c1.541,0,3.041,1.541,3.041,3.041v5.54h30.614L252.209,94.097L252.209,94.097z M174.527,53.486L162.49,94.097h24.325L174.527,53.486 z M247.794,94.097l-12.038-40.611l-12.287,40.611H247.794z"></path>{" "}
      </g>
    </svg>,
    <svg
      className="fill-lightBlue w-full h-full"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 249"
      enableBackground="new 0 0 256 249"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path d="M47.522,170.287l11.172,76.681h138.612l11.172-76.681H47.522z M128,215.249c-5.748,0-10.407-3.063-10.407-6.84 s4.659-6.84,10.407-6.84c5.748,0,10.407,3.062,10.407,6.84S133.748,215.249,128,215.249z M233.315,233.054h-26.028l10.292-70.639 H38.421l10.292,70.639H22.685c-14.848,0-24.85-15.195-18.978-28.834l36.809-85.489c7.149-16.605,23.493-27.362,41.571-27.362h14.486 l22.885,34.061l4.665-22.254l-7.809-11.807h23.491l-7.81,11.807l4.655,22.098l22.78-33.905h14.486 c18.078,0,34.422,10.757,41.571,27.362l36.808,85.489C258.165,217.858,248.164,233.054,233.315,233.054z M128,2.033 c22.496,0,40.733,18.237,40.733,40.733S150.496,83.498,128,83.498S87.267,65.261,87.267,42.765S105.504,2.033,128,2.033z"></path>{" "}
      </g>
    </svg>,
    <svg
      className="fill-lightBlue w-full h-full"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <title>translate</title>{" "}
        <g id="Layer_2" data-name="Layer 2">
          {" "}
          <g id="invisible_box" data-name="invisible box">
            {" "}
            <rect width="48" height="48" fill="none"></rect>{" "}
          </g>{" "}
          <g id="icons_Q2" data-name="icons Q2">
            {" "}
            <path d="M43.8,41.2,33.9,16.3A2.1,2.1,0,0,0,32,15H30a2.1,2.1,0,0,0-1.9,1.3L23.3,28.4a24,24,0,0,1-5.6-4.3c3.4-4,5.9-8.8,6.2-13.1h2A2.1,2.1,0,0,0,28,9.3,2,2,0,0,0,26,7H17.5V4.1A2.1,2.1,0,0,0,15.8,2a2,2,0,0,0-2.3,2V7H6.1A2.1,2.1,0,0,0,4,8.7,2,2,0,0,0,6,11H19.9c-.3,3-2.3,6.7-4.9,10.1a34.1,34.1,0,0,1-3.2-4.9A2.1,2.1,0,0,0,9.6,15a2,2,0,0,0-1.4,2.9,39.1,39.1,0,0,0,4.1,6.2,24,24,0,0,1-7,5A2.2,2.2,0,0,0,4,31.4,2,2,0,0,0,6,33l.8-.2A26.4,26.4,0,0,0,15,27a28.1,28.1,0,0,0,6.8,5.1l-3.6,9.1A2,2,0,0,0,20,44a2.2,2.2,0,0,0,1.9-1.3L25.8,33H36.2l3.9,9.7A2.2,2.2,0,0,0,42,44a2,2,0,0,0,1.8-2.8ZM27.4,29,31,19.9,34.6,29Z"></path>{" "}
          </g>{" "}
        </g>{" "}
      </g>
    </svg>,
    <svg
      className="fill-lightBlue w-full h-full"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path d="M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z"></path>{" "}
        <path d="M19.0206 3.48162C17.0806 1.54162 15.1806 1.49162 13.1906 3.48162L11.9806 4.69162C11.8806 4.79162 11.8406 4.95162 11.8806 5.09162C12.6406 7.74162 14.7606 9.86162 17.4106 10.6216C17.4506 10.6316 17.4906 10.6416 17.5306 10.6416C17.6406 10.6416 17.7406 10.6016 17.8206 10.5216L19.0206 9.31162C20.0106 8.33162 20.4906 7.38162 20.4906 6.42162C20.5006 5.43162 20.0206 4.47162 19.0206 3.48162Z"></path>{" "}
        <path d="M15.6103 11.5308C15.3203 11.3908 15.0403 11.2508 14.7703 11.0908C14.5503 10.9608 14.3403 10.8208 14.1303 10.6708C13.9603 10.5608 13.7603 10.4008 13.5703 10.2408C13.5503 10.2308 13.4803 10.1708 13.4003 10.0908C13.0703 9.81078 12.7003 9.45078 12.3703 9.05078C12.3403 9.03078 12.2903 8.96078 12.2203 8.87078C12.1203 8.75078 11.9503 8.55078 11.8003 8.32078C11.6803 8.17078 11.5403 7.95078 11.4103 7.73078C11.2503 7.46078 11.1103 7.19078 10.9703 6.91078C10.9491 6.86539 10.9286 6.82022 10.9088 6.77532C10.7612 6.442 10.3265 6.34455 10.0688 6.60231L4.34032 12.3308C4.21032 12.4608 4.09032 12.7108 4.06032 12.8808L3.52032 16.7108C3.42032 17.3908 3.61032 18.0308 4.03032 18.4608C4.39032 18.8108 4.89032 19.0008 5.43032 19.0008C5.55032 19.0008 5.67032 18.9908 5.79032 18.9708L9.63032 18.4308C9.81032 18.4008 10.0603 18.2808 10.1803 18.1508L15.9016 12.4295C16.1612 12.1699 16.0633 11.7245 15.7257 11.5804C15.6877 11.5642 15.6492 11.5476 15.6103 11.5308Z"></path>{" "}
      </g>
    </svg>,
  ];

  return (
    <div className="py-[30px] radial-backer">
      <div className="relative width-container">
        <div className="flex gap-[40px] break950:gap-[80px] flex-wrap justify-between">
          <div className="flex-1 flex flex-col items-start justify-center gap-6">
            <div className="iconLight">
              <svg
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <title>hand-holding-heart</title>{" "}
                  <path d="M29.064 19.701c-0.421-0.177-0.91-0.28-1.423-0.28-0.577 0-1.123 0.13-1.611 0.362l0.023-0.010-5.778 2.595c0.003-0.047 0.026-0.087 0.026-0.134-0.015-1.371-1.129-2.476-2.502-2.476-0.069 0-0.137 0.003-0.204 0.008l0.009-0.001h-3.783l-4.76-1.395c-0.062-0.020-0.133-0.031-0.207-0.031-0.001 0-0.003 0-0.004 0h-2.169v-0.757c-0-0.414-0.336-0.75-0.75-0.75h-3.883c-0.414 0-0.75 0.336-0.75 0.75v0 12.208c0 0.414 0.336 0.75 0.75 0.75h3.883c0.414-0 0.75-0.336 0.75-0.75v0-1.005c1.818 0.284 3.445 0.742 4.987 1.367l-0.149-0.054c1.15 0.416 2.478 0.656 3.862 0.656 0.007 0 0.014 0 0.021-0h-0.001c0.005 0 0.011 0 0.017 0 1.604 0 3.133-0.319 4.528-0.898l-0.078 0.029c1.243-0.553 2.298-1.136 3.297-1.799l-0.082 0.051c0.338-0.209 0.674-0.418 1.014-0.619 1.633-0.967 2.945-1.816 4.129-2.672 0.579-0.412 1.083-0.819 1.563-1.253l-0.014 0.013c0.373-0.302 0.671-0.682 0.871-1.116l0.008-0.019c0.031-0.079 0.048-0.17 0.048-0.266 0-0.057-0.006-0.112-0.018-0.165l0.001 0.005c-0.146-1.017-0.755-1.866-1.603-2.337l-0.016-0.008zM5.181 29.041h-2.383v-10.709h2.383zM28.719 22.541c-0.412 0.37-0.86 0.729-1.328 1.062l-0.047 0.032c-1.143 0.826-2.418 1.65-4.014 2.596-0.348 0.205-0.691 0.418-1.037 0.631-0.854 0.573-1.837 1.12-2.864 1.586l-0.13 0.053c-1.152 0.474-2.49 0.748-3.892 0.748-1.203 0-2.359-0.203-3.436-0.575l0.074 0.022c-1.555-0.648-3.363-1.145-5.248-1.407l-0.117-0.013v-7.436h2.062l4.76 1.395c0.062 0.020 0.133 0.031 0.207 0.031 0.001 0 0.003 0 0.004 0h3.89c0.883 0 1.197 0.521 1.197 0.969s-0.314 0.969-1.197 0.969h-6.809c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h7.781c0.001 0 0.003 0 0.004 0 0.11 0 0.214-0.024 0.307-0.068l-0.004 0.002 7.795-3.5c0.288-0.132 0.625-0.209 0.98-0.209 0.265 0 0.52 0.043 0.758 0.122l-0.017-0.005c0.383 0.23 0.658 0.604 0.752 1.046l0.002 0.011c-0.136 0.159-0.278 0.302-0.429 0.435l-0.005 0.004zM16.432 16.74c0.138 0.153 0.336 0.248 0.557 0.248s0.419-0.095 0.556-0.247l0.001-0.001 5.969-6.616c1.082-1.007 1.774-2.421 1.832-3.997l0-0.010c0-0.012 0-0.026 0-0.040 0-1.332-0.543-2.536-1.42-3.405l-0-0c-0.904-0.878-2.138-1.42-3.5-1.42-1.334 0-2.546 0.52-3.445 1.367l0.003-0.002c-0.851-0.723-1.962-1.163-3.176-1.163-0.432 0-0.85 0.056-1.249 0.16l0.034-0.008c-1.754 0.498-3.107 1.852-3.597 3.569l-0.009 0.037c-0.094 0.364-0.148 0.781-0.148 1.212 0 1.455 0.619 2.766 1.609 3.683l0.003 0.003zM10.437 5.601c0.351-1.238 1.306-2.193 2.518-2.539l0.026-0.006c0.249-0.070 0.536-0.11 0.832-0.11h0c1.048 0.034 1.983 0.493 2.643 1.209l0.002 0.003c0.136 0.136 0.323 0.22 0.53 0.22s0.395-0.084 0.53-0.22v0c0.742-0.818 1.79-1.347 2.961-1.407l0.010-0h0.025c1.842 0.012 3.33 1.508 3.33 3.351 0 0.002 0 0.003 0 0.005v-0c-0.060 1.182-0.589 2.229-1.403 2.969l-0.003 0.003-0.027 0.028-5.424 6.013-5.45-6.041c-0.737-0.651-1.199-1.598-1.199-2.653 0-0.292 0.035-0.576 0.102-0.848l-0.005 0.024z"></path>{" "}
                </g>
              </svg>
            </div>
            <h3 className="text-[28px] break650:text-3xl uppercase font-medium leading-none">
              {title[language]}
            </h3>
            <p className="text-lg leading-relaxed">{text[language]}</p>
            <div className="w-full flex gap-3 break650:gap-6">
              {professions.map((item, index) => (
                <div
                  key={index}
                  className="p-4 bg-lightColor g-shadow rounded-lg"
                >
                  <div className="flex items-center justify-between h-8 w-8 break950:w-16 break950:h-16">
                    {item}
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6">
              <Link
                to="/contact"
                className="block px-6 py-3 font-bold tracking-widest uppercase rounded-lg bg-lightBlue g-shadow text-white"
              >
                {link[language]}
              </Link>
            </div>
          </div>
          <div className="hidden break700:flex basis-0 grow shrink break1070:grow-0 break1070:basis-[450px] justify-center items-center">
            <img
              className="rounded-lg w-full max-w-[400px]"
              alt="volunteer"
              src="images/getinvolved/volonteer-upsplash.avif"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionVolonter;
